import React from 'react';
import { useHistory } from 'react-router-dom';
import { string, bool, number, arrayOf, shape, func } from 'prop-types';
import { GiftFlowContext, TOGGLE_PLAN_TYPE } from '../../GiftFlow/GiftFlow';
import styles from './styles/styles.module.scss';
import BulletList from '../../../shared/text/BulletList';
import Expandable from '../../../shared/Expandable';
import PlanType from '../../../forms/pro/PlanType';
import CheckCircleIcon from '../../../../../assets/images/pro/greenCheck-filled.svg';
import { StringConstantsMixin, ProPageStrings } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { pushHistory } from '../../../../utils/client_side_routing_helpers';

const {
  strings: {
    GIFT_FLOW: { GIVE_THE_GIFT, FEATURES_DESIGNED_FOR_ALL, PICK_YOUR_GIFT, BUY_GIFT }
  }
} = StringConstantsMixin;

const FEATURES = ProPageStrings.featuresList.slice(0, 4);

const BulletIcon = () => {
  return <img src={CheckCircleIcon} alt="checkmark" className={styles.checkMarkIcon} />;
};

const GiftingHeader = ({ planTypes, currencyCode, languageRegionCode }) => {
  const history = useHistory();
  const {
    giftFlowState: { activePlanType },
    dispatchGiftFlow
  } = React.useContext(GiftFlowContext);

  const handleSubmit = () => {
    pushHistory('/gift/customize', history, languageRegionCode);
  };

  const handlePlanTypeClick = payload => {
    dispatchGiftFlow({ type: TOGGLE_PLAN_TYPE, payload });
  };

  const bulletList = <BulletList classes={styles.bulletList} bullet={<BulletIcon />} list={FEATURES} />;

  return (
    <section className={styles.container}>
      <div className={styles.banner} />
      <div className={styles.featuresAndChoose}>
        <div className={styles.features}>
          <h1 className={styles.featureHeader} data-test-id="give_the_gift">{GIVE_THE_GIFT}</h1>
          <div className={styles.mobileBulletList}>
            <Expandable title={FEATURES_DESIGNED_FOR_ALL} classes={styles.bulletList}>
              {bulletList}
            </Expandable>
          </div>
          <div className={styles.desktopBulletList}>{bulletList}</div>
        </div>
        <div className={styles.planType}>
          <PlanType
            text={{ headText: PICK_YOUR_GIFT, submitText: BUY_GIFT }}
            handleSubmit={handleSubmit}
            handleClick={handlePlanTypeClick}
            activePlanType={activePlanType}
            planTypes={planTypes}
            currencyCode={currencyCode}
          />
        </div>
      </div>
    </section>
  );
};

GiftingHeader.propTypes = {
  currencyCode: string,
  planTypes: arrayOf(
    shape({
      allowCoupon: bool,
      numberOfMonths: string,
      planCode: string,
      priceMonth: number,
      priceTotal: number,
      showDiscount: bool
    })
  ).isRequired
};

GiftingHeader.defaultProps = {
  currencyCode: 'USD'
};

GiftingHeader.contextTypes = {
  giftFlowState: shape({
    activePlanType: string
  }),
  dispatchGiftFlow: func
};

export default GiftingHeader;
